import styled from 'styled-components'

import LeftBar from '../../pages/home/components/leftBar'
import FlowCreator from './flow'

const DIV = styled.div`
    display: flex;
    height: 100vh;
    overflow: hidden !important;
`

const Page = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    scroll-behavior: smooth;
    overflow: auto;
    flex: 1;
`

export default function FlowPage() {
    return (
        <DIV>
            <LeftBar />
            <Page>
                <FlowCreator />
            </Page>
        </DIV>
    )
}
